<template>
  <el-card>
    <div slot="header" class="font-weight-bold text-left">
      {{ $t('general.customer') }}
    </div>
    <div>
      <table v-if="customer" class="el-table el-table--striped">
        <tr>
          <th class="w-50 pr-1">
            {{ $t('general.name') }}
          </th>
          <td>{{ fullName }}</td>
        </tr>
        <tr>
          <th class="w-50 pr-1">
            {{ $t('general.company') }}
          </th>
          <td>{{ customer.company }}</td>
        </tr>
        <tr>
          <th class="w-50 pr-1">
            {{ $t('general.email') }}
          </th>
          <td>{{ customer.email }}</td>
        </tr>
        <tr>
          <th class="w-50 pr-1">
            {{ $t('general.address') }}
          </th>
          <td>{{ customerAddress }}</td>
        </tr>
        <tr>
          <th class="w-50 pr-1">
            {{ $t('general.phone') }}
          </th>
          <td>{{ customer.phone }}</td>
        </tr>
        <tr v-if="deliveryAddress">
          <th class="w-50 pr-1">
            {{ $tc('general.delivery_address', 1) }}
          </th>
          <td>
            <div style="line-height: 20px" v-html="deliveryAddress.fullAddress()" />
          </td>
        </tr>
        <tr v-if="deliveryDate">
          <th class="w-50 pr-1">
            {{ $t('checkout.delivery_date') }}
          </th>
          <td>{{ deliveryDate }}</td>
        </tr>
      </table>
    </div>
  </el-card>
</template>

<script>
import User from '../../../../api/dto/User';
import DeliveryAddress from '../../../../api/dto/DeliveryAddress';

export default {
  name: 'OrderCustomerCard',
  components: {},
  props: {
    customer: {
      type: User,
      default: () => null,
    },
    deliveryAddress: {
      type: DeliveryAddress,
      default: () => new DeliveryAddress(),
    },
    deliveryDate: {
      type: String,
      default: () => new String(),
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    fullName() {
      return `${this.customer.firstname} ${this.customer.lastname}`;
    },
    customerAddress() {
      return `${this.customer.street}, ${this.customer.zipCode} ${this.customer.city}`;
    },
  },
  methods: {},
};
</script>

<style scoped></style>
